import axios from "axios";
import { BASE_URL } from "../Global";
import useAuthStore from "../Store/AuthStore";

export const SendCareerFormData = async (formData) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/partner/careerform`,
            JSON.stringify(formData),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const SendPartnerFormData = async (formData) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.post(
            `${BASE_URL}/api/partner/partnerform`,
            JSON.stringify(formData),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const SendShopifyFormData = async (formData) => {
    const { token, email } = useAuthStore.getState();
    try {
        const response = await axios.post(
            `${BASE_URL}/api/partner/shopifyform`,
            JSON.stringify(formData),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};
